import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import { RaiseColors, Drawer, makeStyles } from "client/componentLibrary";
import { useTheme } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useNewStyles = makeStyles(function (theme) {
  return {
    drawerPaper: _defineProperty({
      backgroundColor: RaiseColors.neutral200,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "100%",
      width: function width(props) {
        return props.width ? props.width : undefined;
      }
    }, theme.breakpoints.down(_valuesInstanceProperty(theme.breakpoints).tablet), {
      width: "auto !important"
    }),
    drawerHeader: _defineProperty(_defineProperty({
      alignSelf: "stretch",
      display: "flex",
      alignContent: "center",
      justifyContent: "space-between",
      backgroundColor: RaiseColors.white,
      alignItems: "center",
      padding: "16px 24px"
    }, theme.breakpoints.down(_valuesInstanceProperty(theme.breakpoints).tablet), {
      padding: "16px"
    }), theme.breakpoints.down(_valuesInstanceProperty(theme.breakpoints).smMd), {
      padding: "12px 16px"
    }),
    drawerBody: _defineProperty({
      flexGrow: 1,
      overflow: "auto",
      padding: "24px"
    }, theme.breakpoints.down(_valuesInstanceProperty(theme.breakpoints).tablet), {
      padding: "16px"
    }),
    // work to do, what exists in the footer should be mobile and padding not the flex.
    drawerFooter: _defineProperty(_defineProperty({
      alignSelf: "stretch",
      display: "flex",
      gap: "16px",
      alignContent: "center",
      justifyContent: "flex-end",
      backgroundColor: RaiseColors.white,
      padding: "20px 24px"
    }, theme.breakpoints.down(_valuesInstanceProperty(theme.breakpoints).tablet), {
      padding: "16px"
    }), theme.breakpoints.down(_valuesInstanceProperty(theme.breakpoints).smMd), {
      padding: "12px 16px"
    })
  };
});
export default function CustomDrawer(_ref) {
  var _useWindowSize$innerW;
  var onClose = _ref.onClose,
    open = _ref.open,
    header = _ref.header,
    body = _ref.body,
    footer = _ref.footer,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "502px" : _ref$width,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "temporary" : _ref$variant,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$showHeaderWhileL = _ref.showHeaderWhileLoading,
    showHeaderWhileLoading = _ref$showHeaderWhileL === void 0 ? false : _ref$showHeaderWhileL;
  var classes = useNewStyles({
    width: width
  });
  var theme = useTheme();
  var windowWidth = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  var isTablet = windowWidth <= _valuesInstanceProperty(theme.breakpoints).tablet;
  return /*#__PURE__*/_jsx(Drawer, {
    variant: variant,
    open: open,
    onClose: onClose,
    anchor: isTablet ? "top" : "right",
    classes: {
      paper: classes.drawerPaper
    },
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [(!isLoading || showHeaderWhileLoading) && /*#__PURE__*/_jsx("div", {
        className: classes.drawerHeader,
        children: header
      }), !isLoading && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.drawerBody,
          children: body
        }), footer ? /*#__PURE__*/_jsx("div", {
          className: classes.drawerFooter,
          children: footer
        }) : null]
      })]
    })
  });
}